/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  constructor(public router: Router) {}

  isPressReleaseScreen(): boolean {
    // Matches /news/pr1, /news/pr2, /news/pr3, /news/pr4
    return /^\/news\/pr\d+$/i.test(this.router.url);
  }
}
